<template>
    <div class="data-table-container">
        <div class="data-table-scroll">
            <table class="mds-data-table">
                <caption class="mds-data-table__caption">Here is where we want an accurate description about the data displayed and/or the table&#39;s intent</caption>
                <thead class="mds-data-table__header">
                    <tr class="mds-data-table__row">
                        <TableHeading 
                            v-for="(heading, index) in headings"
                            :key="index"
                            :text="heading.text"
                            :isSticky="isSticky(index)"
                            :color="headingColor(heading.color)"
                            :fontColor="headingFontColor(heading.fontColor)"
                        />
                    </tr>
                </thead>
                <tbody class="mds-data-table__body">
                    <TableRow 
                        v-for="(row, index) in rows"
                        :key="index"
                        :row="row"
                    />
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import TableHeading from "./TableHeading";
import TableRow from "./TableRow";

export default {
    data () {
        return {
            $tableContainer: null,
            $tableScrollContainer: null,
            $dataTable: null,
            $rowHeader: null
        };
    },
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    computed: {
        headings () {
            return this.data.headings;
        },
        rows () {
            return this.data.rows;
        }
    },
    components: {
        TableHeading,
        TableRow
    },
    methods: {
        isSticky (index) {
            return index === 0;
        },
        onResize (event) {
            const tableContainerWidth = this.$tableScrollContainer.clientWidth;
            const tableWidth = this.$dataTable.clientWidth;

            if (tableWidth > tableContainerWidth) {
                this.$tableContainer.classList.add("scroll");
                this.$rowHeader.forEach(($element) => {
                    $element.classList.add("sticky");
                    $element.parentElement.style.height = `${$element.clientHeight}px`;
                });
            } else {
                this.$tableContainer.classList.remove("scroll");
                this.$rowHeader.forEach(($element) => {
                    $element.classList.remove("sticky");
                    $element.parentElement.style.height = "initial";
                });
            }
        },
        headingColor (color) {
            return (color && color.trim() !== "") ? color : "transparent";
        },
        headingFontColor (color) {
            return (color && color.trim() !== "") ? color : "#5E5E5E";
        }
    },
    updated () {
        this.$tableContainer = this.$el;
        this.$tableScrollContainer = this.$el.querySelector(".data-table-scroll");
        this.$dataTable = this.$el.querySelector(".mds-data-table");
        this.$rowHeader = this.$el.querySelectorAll(".row-header");

        window.addEventListener("resize", this.onResize);
        this.onResize();
    }
};
</script>

<style lang="scss">
.data-table-container {
    border-right: 1px solid transparent;
    position: relative;

    &.scroll {
        padding-left: 160px;

        &::after,
        &::before {
            background-color: $mds-background-color-default;
            bottom: 0;
            box-shadow: 4px 0px 7px -4px $mds-color-neutral-67;
            content: ' ';
            left: 148px;
            position: absolute;
            top: 0;
            width: $mds-space-1-and-a-half-x;
            z-index: 1;
        }

        &::after {
            box-shadow: -4px 0px 7px -4px $mds-color-neutral-67;
            left: initial;
            right: -12px;
        }

        .data-table-scroll {
            margin-right: $mds-space-1-x;
            overflow: auto;
        }

        &:last-of-type {
            &::after,
            &::before {
                top: -10px;
            }
        }
    }

    .mds-data-table {
        width: auto;
        max-width: initial;

        @media #{$bp-desktop} {
            width: 100%;
        }
    }

    .mds-data-table__cell--center,
    .mds-data-table__header-cell--center {
        text-align: center;
    }

    .row-header {
        position: relative;
        width: 153px;
        z-index: 1;
    }

    .sticky {
        left: 0;
        padding-right: $mds-space-1-and-a-half-x;
        position: absolute;
        width: 160px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Table.vue